import React from "react";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { contactInfoRows } from "../model/constants";

export const ContactInfo: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      alignItems="flex-start"
      gap={2}
    >
      {contactInfoRows.map((contact, index) => (
        <Stack
          key={`${contact.labelKey}-${index}`}
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          gap={2}
        >
          {contact.icon}

          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Typography color="textSecondary">{t(contact.labelKey)}</Typography>
            <Typography color="primary">{t(contact.valueKey)}</Typography>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};
